<template>
  <icon-button icon="trash" :size="14" class-name="btn btn-sm btn-outline-warning" v-on:click="click"></icon-button>
</template>

<script>
import DistributionClass from "@/entities/Distributions/DistributionClass";
import VueFeather from "vue-feather";
import IconButton from "@/elements/IconLink";
export default {
  components: {IconButton, VueFeather},
  props: { item: { type: Object }},
  methods: {
    click() {
      (new DistributionClass(this)).remove(this.$props.item.id);
    }
  }
}
</script>